module.exports = __webpack_public_path__ + "img/service-flow-customer_m.7361ca41.svg";